import React from 'react';
import { getMeasuredWorksheetComponent } from '../..';
import { Message } from '../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { PageSection } from '../../../Layout';
import { IWorksheetComponent } from '../types';

interface IWorksheetMeasuredTestSectionProps extends IWorksheetComponent {
  name: string;
  measuredTestSetup?: React.ReactNode;
  testMethodId?: string;
}

let WorksheetMeasuredTestSection: React.FC<IWorksheetMeasuredTestSectionProps> = ({
  name,
  measuredTestSetup,
  testMethodId,
}) => {
  const WorksheetComponent = getMeasuredWorksheetComponent(testMethodId);

  if (!testMethodId) {
    return (
      <PageSection>
        <Message error>
          The measured test id could not be determined, please ensure the configuration for the test is correct.
        </Message>
      </PageSection>
    );
  } else if (!WorksheetComponent) {
    return (
      <PageSection>
        <Message error>The measured test component could not be found.</Message>
      </PageSection>
    );
  }

  return (
    <>
      {measuredTestSetup}
      {/*
       * Because this will be an associated test, everything inside WorksheetComponent will need additional context
       * Hence we append to the namePrefix here.
       */}
      <NamePrefixModifier appendNamePrefix={name}>
        <WorksheetComponent />
      </NamePrefixModifier>
    </>
  );
};

WorksheetMeasuredTestSection = withInjectedProps(WorksheetMeasuredTestSection);

export default WorksheetMeasuredTestSection;
export type { IWorksheetMeasuredTestSectionProps };
